import { render, staticRenderFns } from "./BankingsREMT.vue?vue&type=template&id=1caf52cc&"
import script from "./BankingsREMT.vue?vue&type=script&lang=js&"
export * from "./BankingsREMT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports